angular.module('unica_workshop_session.workshop_session_controllers')

.controller('WorkshopSessionListController', function(
	$rootScope, $scope, $state, $stateParams,
	$confirm,
	WorkshopSessionListService, WorkshopSessionDeleteService
) {
	$scope.workshopSessionList = [];
	$scope.limit  = 10;
	$scope.offset = 0;
	$scope.canLoad = true;
	$scope.event_id    = $stateParams.event_id;
	$scope.workshop_id = $stateParams.workshop_id;

	$rootScope.getEvent( $stateParams.event_id );

	$rootScope.getWorkshop( $stateParams.workshop_id );

	$scope.loadWorkshopSessionList = function() {
		$scope.showLoader();
		$scope.canLoad = false;

		WorkshopSessionListService
			.list( $stateParams.workshop_id, $scope.limit, $scope.offset )
			.then(function(data) {
				$scope.hideLoader();

				if ( !data.error ) {

					data = $rootScope.parseWorkshopSession( data );

					$scope.workshopSessionList = $scope.workshopSessionList.concat( data );
					if ( data.length == 0 ) {
						$scope.canLoad = false;
					} else {
						$scope.canLoad = true;
						$scope.offset = $scope.offset + data.length;
					}
				} else {
					$rootScope.manageError(data);
				}
			});
	};


	$scope.deleteWorkshopSession = function(workshopSessionId) {

		$confirm({
			title: 'Sei sicuro di voler eliminare questa session?',
			text: 'Confermi la cancellazione della sessione?'
		}).then(function() {

			$scope.showLoader();
			WorkshopSessionDeleteService
				.delete( workshopSessionId )
				.then(function(data) {
					$scope.hideLoader();

					if (!data.error) {
						angular.forEach($scope.workshopSessionList, function(workshopSession, key) {
							if ( workshopSession.id == workshopSessionId ) {
								$scope.workshopSessionList.splice(key, 1);
							}
						});
						$scope.showSuccessMsg('Sessione Workshop eliminata con successo!', '');
					} else {
						$rootScope.manageError(data);
					}

				});

		}, function() {
			// Cancel
		});

	};

})

;
